import {InjectionToken} from "@angular/core";
import {IntTestingDataMarkers} from "../types";

export const INT_TESTING_DATA_MARKERS_TOKEN = new InjectionToken<IntTestingDataMarkers>('INT_TESTING_DATA_MARKERS_TOKEN', {
  factory() {
    return {
      mark: 'data-test-el',
      defaultValue: 'data-test-default-value'
    }
  },
  providedIn: 'root'
});
